import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import * as React from "react";
import { connect } from "react-redux";
import { getTheme } from "../../../../11sight/features/base/ui/components/BaseTheme.web";
/**
 * The theme provider for the web app.
 *
 * @param {Object} props - The props of the component.
 * @returns {React.ReactNode}
 */
function JitsiThemeProvider(props) {
    return ((React.createElement(StyledEngineProvider, { injectFirst: true },
        React.createElement(ThemeProvider, { theme: props._theme }, props.children))));
}
function _mapStateToProps(state) {
    return {
        _theme: getTheme()
    };
}
export default connect(_mapStateToProps)(JitsiThemeProvider);
